import { render, staticRenderFns } from "./LoanPaymentLoading.vue?vue&type=template&id=3c564815&"
import script from "./LoanPaymentLoading.vue?vue&type=script&lang=js&"
export * from "./LoanPaymentLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports